import React from "react";
import { TIME_STATUS_DOT_COLORS, TIME_STATUS_LABELS } from "../../core/constants";

function BannerTimeStatusDot({ status, style = {} }) {
  const dotColor = TIME_STATUS_DOT_COLORS[status] || "#999999";
  const label = TIME_STATUS_LABELS[status] || status || "—";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "13px",
        color: dotColor,
        fontWeight: 500,
        ...style,
      }}
    >
      <span
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: dotColor,
          display: "inline-block",
        }}
      />
      {label}
    </span>
  );
}

export default React.memo(BannerTimeStatusDot);
